import ServiceIcon from "./ServiceIcon";
import { SITE } from "../lib/site";
import { motion } from "framer-motion";

export default function TrustBadges({ variant = "hero" }) {
  const isHero = variant === "hero";
  return (
    <ul
      className={`grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 ${
        isHero ? "text-white/85" : "text-[#0A192F]/85"
      }`}
      data-testid="trust-badges"
      aria-label="Trust indicators"
    >
      {SITE.trustBadges.map((b, i) => (
        <motion.li
          key={b.label}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.4 + i * 0.06, duration: 0.6 }}
          className={`flex items-center gap-2.5 px-3.5 py-2.5 border rounded-full text-[11px] sm:text-xs tracking-wide ${
            isHero
              ? "border-white/20 bg-white/[0.04] backdrop-blur-sm"
              : "border-[#0A192F]/12 bg-white"
          }`}
          data-testid={`trust-badge-${b.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          <span className="w-6 h-6 rounded-full border border-[#C5A059]/60 text-[#C5A059] flex items-center justify-center shrink-0">
            <ServiceIcon name={b.icon} className="w-3 h-3" />
          </span>
          <span className="whitespace-nowrap">{b.label}</span>
        </motion.li>
      ))}
    </ul>
  );
}
